import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {NgbDatepickerModule, NgbModule, NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {DpDatePickerModule} from 'ng2-date-picker';
import {ChartModule} from 'angular2-highcharts';
import {AppComponent} from './app.component';
import {PageNotFoundComponent} from './components/page-not-found/page-not-found.component';
import {AppRoutingModule} from './app-routing-module';
import {HeaderComponent} from './components/header/header.component';
import {ImportCustomersModalComponent} from './components/import-customers-modal/import-customers-modal.component';
import {NgxMessagesModule} from 'ngx-messages';
import {CustomersService} from './services/customers.service';
import {SitesTableComponent} from './components/sites/sites-table/sites-table.component';
import {SitesComponent} from './components/sites/sites.component';
import {SitesService} from './services/sites.service';
import {ReviewDatePickerComponent} from './components/review-date-picker/review-date-picker.component';
import {SiteComponent} from './components/site/site.component';
import {PageComponent} from './components/page/page.component';
import {HttpService} from './services/http.service';
import {ChartsService} from './services/charts.service';
import {PageReviewScoresChartComponent} from './components/page/page-review-scores-chart/page-review-scores-chart.component';
import {SitePagesTableComponent} from './components/site/site-pages-table/site-pages-table.component';
import {AverageScoreAccumulatorsComponent} from './components/average-score-accumulators/average-score-accumulators.component';
import {AverageScoreAccumulatorsService} from './services/average-score-accumulators.service';
import {HighchartsStatic} from 'angular2-highcharts/dist/HighchartsService';
import {BaseAfterViewInitComponent} from './components/base-components/after-view-init/base-after-view-init.component';
import {NotificationsComponent} from './components/notifications/notifications.component';
import {NotificationsTableComponent} from './components/notifications/notifications-table/notifications-table.component';
import {NotificationsService} from './services/notifications.service';
import {EmailService} from './services/email.service';
import {LaddaModule} from 'angular2-ladda';
import {Ng2SmartTableModule} from 'ng2-smart-table';
import {PageSpeedScoreRenderComponent} from './ng-smart-table-renderers/table-cell-renderers/page-speed-score-render.component';
import {SiteUrlCellRenderComponent} from './components/sites/sites-table/site-url-cell-render.component';
import {PagePathCellRenderComponent} from './components/site/site-pages-table/page-path-cell-render.component';
import {TriggerCategoriesService} from './services/trigger-categories.service';
import {SitePagesService} from './services/site-pages.service';
import {CustomerCategoriesService} from './services/customer-categories.service';
import {CustomerCategoriesComponent} from './components/customer-categories/customer-categories.component';
import {TriggerCategoriesComponent} from './components/trigger-categories/trigger-categories.component';
import {LocalStorageService} from './services/local-storage.service';
import {SessionStorageService} from './services/session-storage.service';
import {AddPageComponent} from './components/site/add-page/add-page.component';
import {ToastModule, ToastOptions} from 'ng2-toastr/ng2-toastr';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { CookieService } from 'ngx-cookie-service';
import {environment} from '../environments/environment';

declare var require: any;
export function highchartsFactory() {
    return require('highcharts');
}

export class CustomToastOptions extends ToastOptions {
    animate = 'fade';
    dismiss = 'auto';
    positionClass = 'toast-bottom-right';
    showCloseButton = true;
    newestOnTop = true;
    enableHTML = true;
}

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, environment.i18nPath, '.json');
}

@NgModule({
    entryComponents: [
        PageSpeedScoreRenderComponent,
        SiteUrlCellRenderComponent,
        PagePathCellRenderComponent
    ],
    declarations: [
        AppComponent,
        PageNotFoundComponent,
        HeaderComponent,
        SitesComponent,
        ImportCustomersModalComponent,
        SitesTableComponent,
        ReviewDatePickerComponent,
        SiteComponent,
        SitePagesTableComponent,
        PageComponent,
        PageReviewScoresChartComponent,
        AverageScoreAccumulatorsComponent,
        BaseAfterViewInitComponent,
        NotificationsComponent,
        NotificationsTableComponent,
        PageSpeedScoreRenderComponent,
        SiteUrlCellRenderComponent,
        PagePathCellRenderComponent,
        CustomerCategoriesComponent,
        TriggerCategoriesComponent,
        AddPageComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        FormsModule,
        Ng2SmartTableModule,
        NgbPaginationModule,
        NgbDatepickerModule,
        ReactiveFormsModule,
        NgbModule.forRoot(),
        NgxMessagesModule.configure({showErrorsOnlyIfInputDirty: true}),
        ChartModule,
        DpDatePickerModule,
        LaddaModule.forRoot({
            style: 'slide-right',
            spinnerSize: 20,
            spinnerColor: '#fff',
            spinnerLines: 8
        }),
        ToastModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    providers: [
        {
            provide: HighchartsStatic,
            useFactory: highchartsFactory
        },
        {
            provide: ToastOptions,
            useClass: CustomToastOptions
        },
        CustomersService,
        SitesService,
        TriggerCategoriesService,
        SitePagesService,
        AverageScoreAccumulatorsService,
        HttpService,
        ChartsService,
        NotificationsService,
        EmailService,
        CustomerCategoriesService,
        TriggerCategoriesService,
        LocalStorageService,
        SessionStorageService,
        CookieService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/app.module.ts